// extracted by mini-css-extract-plugin
export default {"wrapper":"AddGoalCard_wrapper__efq0k","title":"AddGoalCard_title__S05i4","icon":"AddGoalCard_icon__jN1n+"};